import NFT from '../../public/images/svg-icon/nft-api.svg';
import API from '../../public/images/svg-icon/API.svg';
import Build from '../../public/images/svg-icon/Build.svg';
import Monitor from '../../public/images/svg-icon/Monitor.svg';
import Notify from '../../public/images/svg-icon/Notify.svg';
import Supernode from '../../public/images/svg-icon/Supernode.svg';
import Brownie from '../../public/images/svg-icon/Brownie.svg';
import Alchemy from '../../public/images/svg-icon/Alchemy.svg';
import Solana from '../../public/images/svg-icon/Solana.svg';

export const technology_stack_data = [
  {
    title: 'Smart Contract Development',
    tech: [
      { icon: 'hardhat', name: 'Hardhat' },
      { icon: 'truffle', name: 'Truffle' },
      { icon: Brownie, name: 'Brownie' }
    ]
  },
  {
    title: 'Web3 Native Libraries',
    tech: [
      { icon: 'etherjs', name: 'EtherJS' },
      { icon: 'web3js', name: 'Web3JS' },
      { icon: Alchemy, name: 'Alchemy Web3' }
    ]
  },
  {
    title: 'Decentralized Swap Integration',
    tech: [
      { icon: 'uniswap', name: 'Uniswap' },
      { icon: 'pancake-swap', name: 'Pancake Swap' }
    ]
  },
  {
    title: 'Blockchains',
    tech: [
      { icon: 'ethereum', name: 'Ethereum' },
      { icon: 'polygon', name: 'Polygon' },
      { icon: 'arbitrum', name: 'Arbitrum' },
      { icon: 'binance', name: 'BSC Chain' },
      { icon: 'zk-sync', name: 'ZK Sync' },
      { icon: Solana, name: 'Solana' },
      { icon: 'optimism', name: 'Optimism' }
    ]
  },
  {
    title: 'Block Explorers',
    tech: [
      { icon: 'etherscan', name: 'Etherscan' },
      { icon: 'polygonscan', name: 'Polygonscan' }
    ]
  },
  {
    title: 'Storage And Computing',
    tech: [
      { icon: 'ipfs', name: 'IPFS' },
      { icon: 'filebase', name: 'Filebase' },
      { icon: 'arweave', name: 'Arweave' }
    ]
  },
  {
    title: 'Back-End',
    tech: [
      { icon: 'graphql', name: 'GraphQL' },
      { icon: 'nodejs', name: 'NodeJS' },
      { icon: 'nestjs', name: 'NestJS' }
    ]
  },
  {
    title: 'Front-End',
    tech: [
      { icon: 'reactjs', name: 'ReactJS' },
      { icon: 'nextjs', name: 'NextJS' },
      { icon: 'react-native', name: 'React Native' }
    ]
  },
  {
    title: 'Data Access',
    tech: [
      { icon: Supernode, name: 'Supernode' },
      { icon: Build, name: 'Build' },
      { icon: Monitor, name: 'Monitor' },
      { icon: Notify, name: 'Notify' },
      { icon: API, name: 'API' },
      { icon: NFT, name: 'NFT API' }
    ]
  }
];
